/**
 * PROFİL KAPISI — hangi ekran profil dokümanı okunamayınca TAM-EKRAN durur?
 *
 * ── NEDEN VAR ────────────────────────────────────────────────────────────
 * Kapı bugüne kadar GLOBAL'di: `users/{uid}` okunamayınca kullanıcı hangi
 * sayfada olursa olsun tam-ekran "Bağlantı kurulamadı" görüyordu — haritada,
 * bildirimlerde, engellenenler listesinde, üretici panelinde de. Bu kapı
 * (EMİR #94.3) gerçek bir hatayı kapattı ve YERİNDE duruyor; sorun kapsamı.
 *
 * ── DARALTMA ÖLÇÜLDÜ, TAHMİN EDİLMEDİ ────────────────────────────────────
 * `scripts/virtual-world/kapi-genisligi.js` iki kollu koştu (kontrol: kurallar
 * serbest · deney: YALNIZ `users/{UID}` okuması reddedildi), 17 ekran.
 *   🟢 ÇÖKMEYEN  → profilsiz de kendi içeriğini render etti
 *   🔴 ÇÖKEN     → profilsiz hiçbir içerik üretemedi
 *   ⚪ ÖLÇÜLEMEDİ → ölçüt profil VARKEN de 0 okudu (ürün değil ALET sınırı)
 *   🔵 MİRAS     → modal rota; ölçüt modalı değil ALTINDAKİ sayfayı sayıyor
 * Ölçüm kaydı: `docs/olcumler/kapi-genisligi-2026-07-28.json` (koşu kimliği,
 * git commit + fixture özetleri dahil). Önceki tur: `...-2026-07-27.json`.
 * ⚠️ Kayıt ÖNCE `scripts/virtual-world/runs/`e yazılıyordu ve o dizin
 * GITIGNORED — yani bu tablonun dayanağı repoda YOKTU, bir sonraki okur onu
 * bulamazdı. ("Kalıcı olmayan bir yerde duran yedek, yedek değildir" kuralının
 * ölçüm eksenindeki hâli.) Karar veren koşu artık repoya kopyalanıyor;
 * `runs/` volatil çalışma alanı olarak kalıyor.
 *
 * ⚠️ ÖLÇÜM ÜÇ TUR SÜRDÜ, HÜKÜM SONUNCUSUNUN. Yol boyunca ÜÇ ölçüm kusuru
 * bulundu ve her biri tabloyu değiştirdi:
 *   1. TAKİP KENARI YOKTU — dünyada hiç `following` kaydı yoktu → ana akıştaki
 *      içeriğin tamamı kullanıcının kendisiydi → deneyin kestiği doküman aynı
 *      zamanda o içeriğin YAZARIYDI. İlk turun ÇÖKEN listesi bu yüzden geçersiz.
 *   2. GRUP ANAHTARI className'in TAMAMIYDI — `disc-cell rarity-${x}` gibi
 *      DEĞİŞKE sınıfları anahtara girip tek tip ızgarayı teke bölüyordu.
 *      `/discoveries` bu yüzden "ÖLÇÜLEMEDİ" görünüyordu; ekran çalışıyordu.
 *      Yeni anahtar: kardeşlerin paylaştığı sınıf JETONU (stoplist YOK —
 *      hepsinde olan gruplayıcı, bazısında olan değişke; ayrımı DOM söylüyor).
 *   3. DEĞER GRUP BOYUTUYDU, DOLU OLANLAR DEĞİL — ana akışta kazanan grup
 *      `<ARTICLE>` adet=14 ama dolu=5 (sanallaştırma). Ölçüt "14 içerik" diyordu.
 *      Artık DOLU olanlar raporlanıyor; `home` gerçekte 5/14 dolduruyor.
 *
 * ⚠️ KALAN ALET BOŞLUĞU (daraldı, kapanmadı): modal rotalar `<main>` üstünde
 * açılıyor ve sayfa-geneli ölçüt altındaki ana akışı sayıyordu. `modalKapsami`
 * ile `<main>` dışlanınca `/notifications` (4·4) ve `/p/{id}` (4·4) KENDİ
 * içerikleriyle ölçüldü → ÇÖKMEYEN. Ama `/direct`, `/c/{id}` ve `/place/{id}`
 * modal kapsamında da 0 · 0 okuyor — kendi içerikleri HÂLÂ ölçülmedi ve üçünün
 * sebebi büyük olasılıkla FARKLI (fixture'da sohbet yok · kapsam yanlış
 * atanmış olabilir · mekan kartı liste değil). Ölçülmeden ayrılmayacaklar.
 * `home` serbest olduğu için bu üç rota da serbest kalıyor.
 *
 * ── İKİ KURAL ────────────────────────────────────────────────────────────
 * 1. VARSAYILAN KAPALI. Listede olmayan her şey kapılıdır. Yeni bir sayfa
 *    eklendiğinde sessizce serbest kalmaz; kapı devralır.
 * 2. BEYAN ZORUNLU. `appPages.tsx`'teki her `case` bu iki tablodan BİRİNDE
 *    olmak zorunda — `profilKapisi.test.ts` senkron testi kaynağı okur ve
 *    eksik/çelişkili beyanda DÜŞER. Yazar "karar vermek zorunda kalır";
 *    "görür" yetmez.
 *
 * ⚠️ OKUMA SINIRI (ölçümün kendi uyarısı, silinmesin): tekrarlı-öğe sayımı
 * "ekran BİR ŞEY render etti mi" der, "DOĞRU şeyi render etti mi" DEMEZ. Bir
 * ekran profil alanlarını sessizce kullanıp eksik veriyle dolu görünebilir.
 * Bu yüzden serbest bırakılan ekranlarda ŞERİT (ProfilKesintiSeridi) ZORUNLU:
 * kullanıcı gördüğünün eksik olabileceğini bilmeden bakmasın.
 */

/** Profilsiz de anlamlı render eden ekranlar — ölçümle doğrulandı, şerit gösterilir. */
export const PROFILSIZ_CALISIR: Readonly<Record<string, string>> = Object.freeze({
  home:
    "ÇÖKMEYEN — deney=5 · kontrol=14 (dolu-tabanlı ölçüt). 1. TURDA ÇÖKEN görünüyordu ve o " +
    "hüküm GEÇERSİZDİ: dünyada takip kenarı yoktu, akıştaki içeriğin TAMAMI " +
    "kullanıcının kendi içeriğiydi, deney de tam o yazarın dokümanını kesiyordu. " +
    "Kenarlar eklenince akış komşu içeriğini render etti (vw_ahmet klipleri). " +
    "⚠️ KISMEN DEGRADE, VE SANDIĞIMIZDAN FAZLA: 14 akış yuvasının yalnız 5'i " +
    "doluyor (%36). İlk ölçümde bu 6/8 (%75) görünüyordu çünkü ölçüt grup " +
    "BOYUTUNU raporluyordu, DOLU olanları değil. Kendi içeriği düşüyor, " +
    "«İlk Adımlar» 1/4 yerine 0/4 okuyor. Şerit tam da bunun için zorunlu.",
  clips:
    "ÇÖKMEYEN — `/clips/trending` (16 · 16) ve `/sounds/{id}` (5 · 5), iki kolda " +
    "birebir (trend grubu «mlv3-feed-chip» 16×, ses sayfası 7×). 1. turdaki " +
    "`/c/{id}` ÇÖKEN itirazı DÜŞTÜ: o satır modalın kendisini değil altındaki " +
    "ana akışı ölçüyordu (home boşken 0 okuyordu). ⚠️ `/c/{id}`in KENDİ içeriği " +
    "hâlâ ölçülmedi (modal kapsamında 0 · 0) — açık kalan boşluk.",
  discoveries:
    "ÇÖKMEYEN — deney=3 · kontrol=3. ÖNCEKİ TURLARDA «ÖLÇÜLEMEDİ» İDİ VE SEBEBİ " +
    "ÜRÜN DEĞİL ÖLÇÜTTÜ: hücre sınıfları `disc-cell rarity-${r}` üretiyor, eski " +
    "grup anahtarı className'in TAMAMIydı → tek tip ızgara teke bölünüyordu. " +
    "Jeton-tabanlı yeni ölçütle görünür oldu (kazanan grup 3× «<SECTION>», " +
    "`disc-cell` de 3×3). Bir tur boyunca «fixture eksik» sanılmıştı; değildi.",
  map:
    "ÇÖKMEYEN (ölçüm: deney=4 · kontrol=4, birebir aynı). Harita kendi verisini " +
    "çekiyor; `currentUserProfile` prop olarak GİRİYOR ama içeriği ona bağlı değil.",
  explore:
    "ÇÖKMEYEN (deney=8 · kontrol=8, grup «explore-grid-item»). Keşfet global " +
    "içerik sorguları üzerinden çalışıyor.",
  creatorDashboard:
    "ÇÖKMEYEN (deney=6 · kontrol=6, grup «cd-clip-card»). Panel `clips` " +
    "koleksiyonunu authorId ile sorguluyor.",
  blockedUsers:
    "ÇÖKMEYEN (deney=3 · kontrol=3). `users/{uid}/blocked` ALT koleksiyon — profil " +
    "dokümanının kendisi gerekmiyor.",
  gizliKelimeler:
    "ÇÖKMEYEN — ⚠️ SANAL DÜNYADA ÖLÇÜLMEDİ (ekran kataloğunda yok; yeni). Hüküm " +
    "KAYNAKTAN: sayfa YALNIZ `users/{uid}/preferences/hiddenWords` ALT " +
    "dokümanını okuyor (`useGizliKelimeler`) ve profil dokümanının hiçbir " +
    "alanına dokunmuyor — `blockedUsers` ile aynı şekil (alt koleksiyon, " +
    "owner-only). Kataloğa girince ölçülüp bu satır TAZELENMELİ; bugünkü " +
    "dayanağı ölçüm değil, okuma yolunun kendisidir.",
  oneriAyarlari:
    "ÇÖKMEYEN — ⚠️ SANAL DÜNYADA ÖLÇÜLMEDİ (yeni ekran). Hüküm KAYNAKTAN: sayfa " +
    "hiçbir Firestore okuması YAPMIYOR; yalnız oturum uid'ini alıp IndexedDB " +
    "temizliği + bir callable çağırıyor. Profil dokümanı yokken de tam " +
    "anlamlıdır (sıfırlanacak yerel geçmiş yine vardır).",
});

/**
 * Profil dokümanı gerçekten gereken ekranlar — kapı tam-ekran devralır.
 * Bu tablo DAVRANIŞ için gerekli DEĞİL (varsayılan zaten kapalı); senkron
 * testinin "yazar bilerek karar verdi" şartını taşımak için var.
 */
export const PROFIL_ZORUNLU: Readonly<Record<string, string>> = Object.freeze({
  profile:
    "ÇÖKEN (deney=0 · kontrol=13). Profil ekranı tanım gereği profil dokümanına " +
    "bağlı; üç turun üçünde de 0 okudu.",
  mylive:
    "ÖLÇÜLEMEDİ — deney=0 · kontrol=0. `discoveries` ile AYNI ETİKET AMA FARKLI " +
    "SEBEP: orada liste vardı ve ölçüt tanımıyordu; burada görülecek liste YOK. " +
    "Ekran bir giriş sahnesi («Her bağlantıda yeni bir his / Başla»), tekrarlı " +
    "grubu hiç yok. Jeton-tabanlı ölçüt bunu da 0 okuyor — çünkü ölçülecek " +
    "şey yok. Farklı bir ölçüt gerekir; ölçülmemiş ekran serbest bırakılmaz.",
  adminReports:
    "ÖLÇÜLMEDİ — ekran kataloğunda yoktu (yönetici yüzeyi). Varsayılan kapalı.",
  adminCostDashboard:
    "ÖLÇÜLMEDİ — ekran kataloğunda yoktu (yönetici yüzeyi). Varsayılan kapalı.",
});

/**
 * Kapı bu sayfada tam-ekran devralsın mı?
 * VARSAYILAN KAPALI: tanınmayan/`undefined` sayfa → true.
 */
export function profilKapisiGerekliMi(activePage: string | null | undefined): boolean {
  if (!activePage) return true;
  return !Object.prototype.hasOwnProperty.call(PROFILSIZ_CALISIR, activePage);
}

/** Serbest bırakılan ekranda kullanıcıya gösterilecek şerit gerekiyor mu? */
export function kesintiSeridiGerekliMi(
  profileUnreachable: boolean,
  activePage: string | null | undefined,
): boolean {
  return !!profileUnreachable && !profilKapisiGerekliMi(activePage);
}
